module.exports = __webpack_public_path__ + "static/media/scrubblitz-5.7ecfd428.jpg";